import { NgModule } from "@angular/core";
import { EscapeHtmlPipe } from "./keep-html.pipe";
import { DateFormatPipe } from "./date-format.pipe";
import { GetFirstCharPipe } from "./get-first-char.pipe";
import { SVGFallback } from "./svg-fallback.pipe";
import { CurrencyFormatPipe } from "./currency-format.pipe";
import { CompanyFederalNumberFormatPipe } from "./company-federal-number-format.pipe";
import { SocialNumberFormatPipe } from "./social-number-format.pipe";
import { MobileFormatPipe } from "./mobile-format.pipe";
import { CardNumberFormatPipe } from "./card-number-format.pipe";
import { CurrencyPbmPipe } from "./pbm-currency-format.pipe";
import { FormPaymentPipe } from "./formPayment.pipe";
import { EnumValuePipe } from "./enum-value.pipe";
import { RegistroGeralPipe } from "./registro-geral-pipe.pipe";

@NgModule({
  declarations: [
    EscapeHtmlPipe,
    DateFormatPipe,
    EnumValuePipe,
    GetFirstCharPipe,
    SVGFallback,
    CompanyFederalNumberFormatPipe,
    CurrencyFormatPipe,
    SocialNumberFormatPipe,
    MobileFormatPipe,
    CardNumberFormatPipe,
    CurrencyPbmPipe,
    FormPaymentPipe,
    RegistroGeralPipe
  ],
  exports: [
    EscapeHtmlPipe,
    DateFormatPipe,
    EnumValuePipe,
    GetFirstCharPipe,
    SVGFallback,
    CompanyFederalNumberFormatPipe,
    CurrencyFormatPipe,
    SocialNumberFormatPipe,
    MobileFormatPipe,
    CardNumberFormatPipe,
    CurrencyPbmPipe,
    FormPaymentPipe,
    RegistroGeralPipe
  ],
})
export class PipeModule {}
